import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Input, Button, Select, message } from "antd";

const { Option } = Select;

class FormThree extends React.Component {
  signersGroupUsersOnSelect = (value) => {
    const { form } = this.props;
    const { getFieldValue } = form;

    const signersGroupUsersValue = getFieldValue("signers_group_users");

    if (signersGroupUsersValue && value) {
      if (value === "no_email") {
        message.error("Selected user doesn't have email.");
        const filterVal = signersGroupUsersValue.filter((key) => key !== value);
        this.props.form.setFieldsValue({
          signers_group_users: filterVal,
        });
      }
    }
  };

  render() {
    const { onSubmit, form, signersGroupsGetData } = this.props;
    const { getFieldDecorator } = form;

    const usersOptions = signersGroupsGetData.users.map((d) => (
      <Option key={d._id} value={d.email ? d._id : "no_email"}>
        {d.name} - {d.user_name} - {d.email ? d.email : <b>No user email</b>}
      </Option>
    ));

    return (
      <Form 
        labelCol={{
          xs: { span: 24 },
          sm: { span: 6 },
          md: { span: 6 },
          lg: { span: 5 },
          xl: { span: 5 },
          xxl: { span: 5 },
        }}
        wrapperCol={{
          xs: { span: 24 },
          sm: { span: 18 },
          md: { span: 18 },
          lg: { span: 15 },
          xl: { span: 12 },
          xxl: { span: 12 },
        }}
        onSubmit={onSubmit}
      >
        <Form.Item label="Group Name">
          {getFieldDecorator("signers_group_name", {
            rules: [
              {
                required: true,
                message: "Please Enter Group Name",
              },
              {
                max: 47,
                message: "Maximum characters reached"
              }
            ],
          })(<Input placeholder="Enter Group Name" maxLength={48}/>)}
        </Form.Item>

        <Form.Item label="User(s)">
          {getFieldDecorator("signers_group_users", {
            rules: [
              {
                required: true,
                message: "Please Enter User(s)",
              },
            ],
          })(
            <Select
              mode="multiple"
              showSearch
              placeholder="Enter User(s)"
              // onChange={this.signersGroupUsersOnChange}
              // onSelect={(e) => this.signersGroupUsersOnChange(e)}
              onSelect={this.signersGroupUsersOnSelect}
              optionFilterProp="children"
              notFoundContent={null}
            >
              {usersOptions}
            </Select>
          )}
        </Form.Item>

        <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
          <Button type="primary" htmlType="submit">
            Add
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const WrappedApp = Form.create({ name: "form_three" })(FormThree);

export default WrappedApp;
